import React, { Component } from 'react';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from 'reactstrap';



import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  forgotPasswordUser
} from '../../modules/agent';

const initialState = {
  credentials: {
    email: '',
  },
  errorMessage: '',
  success:""
};

class ForgotPassword extends Component {

  state = {
    ...initialState,
  };

  handleChange = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const { name, value } = e.currentTarget;
    const { credentials } = this.state;
    credentials[name] = value;
    this.setState({ credentials });
  };

  handleSubmit = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const {forgotPasswordUser, history: { push } } = this.props;

    this.setState(Object.assign(this.state, {
      errorMessage: ''
    }));

   /* logInUser(this.state.credentials)
      .then(() => push('/'))
      .catch(e => {
        const error = e.response && e.response.data && e.response.data.error;

        this.setState(Object.assign(this.state, {
          errorMessage: (error && error.message) ||'Login Failed'
        }));
      }); */
      forgotPasswordUser(this.state.credentials)
      .then(() => push('/'))
      .catch(e => {
        const error = e.response && e.response.data && e.response.data.error;

        this.setState(Object.assign(this.state, {
          errorMessage: (error && error.message) ||'Check your email for reset password',
          credentials: {email: (error && error.message) ? this.state.credentials.email: ""}
        }));
        this.setState(Object.assign(this.state, {
          success: (error && error.message) ? 0 : 1
        }));
      });
  };

  render() {
    const { credentials, errorMessage, success } = this.state;
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row>
         {
        !!errorMessage && (
          <Col xs="12">
            <Alert color={this.state.success == 1 ? "success": "danger"} className="text-center">
              {errorMessage}
            </Alert>
          </Col>
          )
        }
       </Row>
          <Row className="justify-content-center">
            <Col md="10" lg="6">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <h1>Forgot Password</h1>
                      <p className="text-muted">Request to change password</p>
                      <FormGroup>
                      <p>User email</p>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              @
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="email"
                            placeholder="Email"
                            name="email"
                            value={credentials.email}
                            onChange={this.handleChange}
                            required
                          />
                        </InputGroup>
                      </FormGroup>
                      <Row>

                        <Col xs="12">
                          <Button block color="primary" type="submit" className="px-4">Change Password</Button>
                        </Col>
                      </Row>
                       


                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.auth && state.auth.user,
});


const mapDispatchToProps = dispatch => bindActionCreators({
  forgotPasswordUser
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPassword);


// WEBPACK FOOTER //
// ./src/containers/ForgotPassword/ForgotPassword.js